import { AudioConversationMessage } from 'v2/core/entities/feedback/content';

export const getValidAudioDuration = (
  duration: number,
  audioConversation: AudioConversationMessage[],
) => {
  if (audioConversation.length === 0) {
    return duration;
  }

  const fallbackDuration =
    audioConversation[audioConversation.length - 1].metadata.endTime;

  return duration || fallbackDuration;
};
